/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { MyWebVieWModel } from './MyWebVieWModel'


type Props = {
  className: string | undefined
  title: string | undefined
  description: string | undefined
  avatar: string | undefined
  link: string | undefined
}

const WebViewLinkWidget: React.FC<Props> = ({ className, title, description, avatar, link, }) => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <div >
      <a className={` hoverable`} onClick={() => setModalShow(true)}>
        <div
          className={`card shadow-sm  bgi-no-repeat ${className}`}
          style={{
            backgroundPosition: 'right',
            backgroundSize: '18% auto',
            backgroundColor: '#fff',
            backgroundImage: `url(${toAbsoluteUrl('/media/futuriskicon/' + avatar)})`,
          }}
        >
          {/* begin::Body */}
          <div className='card-body'>
            <div className='card-title fw-bolder text-black text-hover-primary fs-4'>
              {title}
            </div>


            <p
              className='text-muted fw-bold fs-7 m-0'
              dangerouslySetInnerHTML={{ __html: description! }}
            ></p>
          </div>
          {/* end::Body */}
        </div>

      </a>
      <MyWebVieWModel show={modalShow} handleClose={() => setModalShow(false)}
        className={className!}
        title={title!}
        description={description!}
        avatar={avatar!}
        link={link} />
    </div>
  )


}

export { WebViewLinkWidget }
